// extracted by mini-css-extract-plugin
module.exports = {"pageMain":"styles_pageMain__gdE4N","container":"styles_container__ju_jB"};